<template>
    <div class="w-full my-4">
        <box-accordion>
            <template slot="summary">
                <div class="w-full flex paymentHistoryItem__summaryContainer">
                    <div class="w-3/5 flex flex-col items-start justify-center">
                        <p
                            class="text-base font-bold m-0"
                            v-html="price">
                        </p>
                        <p
                            v-if="orderSummary"
                            v-text="orderSummary"
                            class="text-sm text-normal m-0">
                        </p>
                    </div>
                    <div v-if="hasDiscount" class="discount">
                        <p class="discount-text" v-text="$t('ORDER_ITEM_DISCOUNT')"></p>
                        <p v-text="discount" class="discount-amount"></p>
                    </div>
                    <div class="w-2/5 flex items-center justify-end">
                        <delivery-date-box
                            class="border border-black"
                            :date="new Date(this.order.delivery_date)">
                        </delivery-date-box>
                    </div>
                </div>
            </template>

            <div class="w-full">
                <!--Payment status & invoice-->
                <div class="w-full h-10 flex border-t border-black">
                    <div class="w-3/12 border-black border-r flex items-center justify-center px-4">
                        <p class="m-0" v-text="paymentStatus"></p>
                    </div>
                    <div class="w-9/12 flex items-center px-4">
                        <a
                            v-if="invoiceUrl"
                            class="w-full"
                            :href="invoiceUrl"
                            target="_blank">
                            <div class="flex items-center justify-between">
                                <p class="m-0 leading-none" v-text="$t('ORDER_ITEM_DOWNLOAD')"></p>
                                <img class="h-4" src="@/assets/images/decoration/arrow-right-black.svg">
                            </div>
                        </a>
                    </div>
                </div>

                <!--Delivery address-->
                <div v-if="hasAddress" class="w-full border-t border-black text-left p-4">
                    <h4 class="m-0 uppercase font-normal" v-text="$t('ORDER_ITEM_DELIVERY')"></h4>
                    <p class="m-0 mt-1 leading-none"
                       v-html="addressCopy">
                    </p>
                </div>

                <!-- View arrangement -->
                <div class="w-full h-10 flex items-center border-t border-black px-4">
                    <router-link class="w-full" :to="{name:'account.your-boxes'}">
                        <div class="flex items-center justify-between">
                            <p class="m-0" v-text="$t('ORDER_ITEM_VIEW_BOX')"></p>
                            <img class="h-4" src="@/assets/images/decoration/arrow-right-black.svg">
                        </div>
                    </router-link>
                </div>
            </div>
        </box-accordion>
    </div>
</template>

<script>
import BoxAccordion from '@/components/structure/BoxAccordion';
import DeliveryDateBox from '@/components/structure/DeliveryDateBox';

export default {
    name: 'OrderItem',
    props: {
        order: {
            required: true,
            type: Object,
        },
    },
    computed: {
        addressCopy() {
            let address = [
                this.order.address.data.address1,
                this.order.address.data.city,
                this.order.address.data.postcode,
            ];

            return address.join('<br />');
        },
        hasAddress() {
            return this.order.address !== undefined;
        },
        hasDiscount() {
            return this.order.pricing.discount > 0;
        },
        paymentStatus() {
            return this.order.payment_status;
        },
        price() {
            return this.order.pricing.currency_symbol + this.order.pricing.total;
        },
        discount() {
            return this.order.pricing.currency_symbol + this.order.pricing.discount;
        },
        invoiceUrl() {
            let invoice = this.order.links.find(item => item.rel === 'invoice') || {};

            return invoice.uri || null;
        },
        orderSummary() {
            if (this.order.box_quantity > 0) {
                return this.order.box_quantity > 1 ? `${this.order.box_quantity} boxes` : `${this.order.box_quantity} box`;
            }

            return null;
        },
    },
    components: {
        BoxAccordion,
        DeliveryDateBox,
    },
};
</script>

<style scoped>
    .discount {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .discount-text {
        font-size: 1rem;
        margin-right: 0.25rem;
    }
    .discount-amount {
        font-size: 1rem;
        margin: 0;
    }
</style>
